import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface RuleError {
  districtName: string;
  workTypeName: string;
  message: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-rule-error-modal',
  templateUrl: './rule-error-modal.component.html',
  styleUrls: ['./rule-error-modal.component.scss'],
  standalone: false,
})
export class RuleErrorModalComponent {
  @Input() errors: RuleError[] = [];
  @Input() title: string = 'Ошибка при создании правила';

  constructor(public activeModal: NgbActiveModal) {}
}
